import { render, staticRenderFns } from "./KpiSimpleCard.vue?vue&type=template&id=72b8d512&scoped=true&"
import script from "./KpiSimpleCard.vue?vue&type=script&lang=js&"
export * from "./KpiSimpleCard.vue?vue&type=script&lang=js&"
import style0 from "./KpiSimpleCard.vue?vue&type=style&index=0&id=72b8d512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b8d512",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
